import { render, staticRenderFns } from "./OurBusiness.vue?vue&type=template&id=992eb830&"
import script from "./OurBusiness.vue?vue&type=script&lang=js&"
export * from "./OurBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports